import { AppSettings } from '../configs';
import { authHeader } from '../helpers/auth-header';
import axios  from "../utils/axios";

const ChangeCommitteeService={};

ChangeCommitteeService.searchPoContractNo = (poContractNo)=>{
    return new Promise((resolve, reject) => {
        axios({
          headers: { ...authHeader(), 'Pragma': 'no-cache' },
          method: "get",
          url: `${AppSettings.apiUrl}/api/ChangeCommittee/SearchPoContractNo`,
          params: {
            poContractNo: poContractNo
          }
        })
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
   
}

ChangeCommitteeService.saveChangeCommittee = (objChangeCommittee) => {
    
  return new Promise((resolve, reject) => {
      axios({
        headers: {...authHeader(),'Pragma': 'no-cache'},
        method: "post",
        url: `${AppSettings.apiUrl}/api/ChangeCommittee/SaveChangeCommittee`,
        data: objChangeCommittee
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })

}

ChangeCommitteeService.setChangeCommittee = (objChangeCommittee) => {
    
  return new Promise((resolve, reject) => {
      axios({
        headers: {...authHeader(),'Pragma': 'no-cache'},
        method: "post",
        url: `${AppSettings.apiUrl}/api/ChangeCommittee/SetChangeCommittee`,
        data: objChangeCommittee
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })

}

ChangeCommitteeService.getChangeCommitteeAll = (poContractNo, user_code)=>{
  return new Promise((resolve, reject) => {
      axios({
        headers: { ...authHeader(), 'Pragma': 'no-cache' },
        method: "get",
        url: `${AppSettings.apiUrl}/api/ChangeCommittee/GetChangeCommitteeAll`,
        params: {
          poContractNo: poContractNo,
          user_code: user_code
        }
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
}

ChangeCommitteeService.getChangeCommittee = (runningId)=>{
  
  return new Promise((resolve, reject) => {
      axios({
        headers: { ...authHeader(), 'Pragma': 'no-cache' },
        method: "get",
        url: `${AppSettings.apiUrl}/api/ChangeCommittee/GetChangeCommittee`,
        params: {
          transaction_no : "",
          change_no : 0,
          runningId: runningId
        }
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
}

ChangeCommitteeService.getCommitteeAttachments = (transaction_change_no)=>{
  
  return new Promise((resolve, reject) => {
      axios({
        headers: { ...authHeader(), 'Pragma': 'no-cache' },
        method: "get",
        url: `${AppSettings.apiUrl}/api/ChangeCommittee/GetCommitteeAttachments`,
        params: {
          transaction_change_no : transaction_change_no
        }
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
}

ChangeCommitteeService.getIsCheckPOCommitteeConfirmAmountByPO = (pono)=>{
  
  return new Promise((resolve, reject) => {
      axios({
        headers: { ...authHeader(), 'Pragma': 'no-cache' },
        method: "post",
        url: `${AppSettings.apiUrl}/api/rrs/IsCheckPOCommitteeConfirmAmountByPO`,
        params: {
          pono : pono
        }
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
}

export default ChangeCommitteeService;
